import React from 'react';

import { Button, BUTTON } from 'components/common/Button/Button';
import Modal from 'components/common/Modal/Modal';

import styles from './AddUserToBinderModal.scss';

const { COLOR, BGCOLOR } = BUTTON;

const AddUserToBinderModal = ({
    isOpen,
    onClose,
    onSave,
    title,
    isDisabled,
    bodyContainer,
    onCancelText,
    onSaveText,
}) => {

    if (!isOpen) {
        return null;
    }

    return (
        <div className={styles.addModal__wrapper} data-cy="AddUserToBinderModal">
            <Modal title={title} open={isOpen} onClose={onClose} fullWidth>
                <div className={styles.addModal__body} data-cy="AddUserToBinderModal-bodyContainer">{bodyContainer}</div>
                <div className={styles.addModal__buttons}>
                    <Button
                        text={onCancelText}
                        outline={BUTTON.OUTCOLOR.MEDIUMGREY}
                        color={COLOR.BLACK}
                        bgcolor={BGCOLOR.WHITE}
                        onClick={onClose}
                        data-testid="ModalAdd__Btn__Cancel"
                        data-cy="AddUserToBinderModal-Cancel"
                    />
                    <Button
                        text={onSaveText}
                        bgcolor={BGCOLOR.BLUE}
                        color={COLOR.WHITE}
                        onClick={onSave}
                        disabled={isDisabled}
                        data-testid="ModalAdd__Btn__SaveChange"
                        data-cy="AddUserToBinderModal-SaveChange"
                    />
                </div>
            </Modal>
        </div>
    );
};

export default AddUserToBinderModal;